import Vue from 'vue'
import NumberFilters from './number'
import DateFilters from './date'
import TextFilters from './text'

Vue.use(NumberFilters)
Vue.use(DateFilters)
Vue.use(TextFilters)
